<script setup lang="ts">
interface Props {
  /** Is the check icon in checked state */
  status?: boolean
  /** Size of the icon */
  size?: string
  /** Whether the icon is disabled */
  disabled?: boolean
}

const { size = '1rem' } = defineProps<Props>()

defineOptions({
  name: 'CheckIcon'
})
</script>

<template>
  <!--
    This extra div is required because otherwise the
    SVG icon will inherit some garbage and make it non-focusable.
  -->
  <div class="check-icon-container flex items-center justify-center">
    <VIcon
      icon="$check"
      :size
      class="check-icon rounded-sm border-2"
      :class="{ checked: status, disabled }"
    />
  </div>
</template>

<style lang="scss" scoped>
@reference "../../styles/main.css";

.check-icon {
  @apply border-secondary-300;
  @apply bg-transparent text-transparent;
  @apply outline-2 outline-transparent outline;

  &:hover:not(.disabled) {
    @apply outline-primary-200 border-primary;
  }

  &.disabled {
    @apply border-gray-300 bg-gray-300;

    &.checked {
      @apply text-white;
    }
  }

  &.checked:not(.disabled) {
    @apply bg-primary border-primary text-white;

    &:hover {
      @apply bg-primary-700 border-primary-700;
    }
  }
}

.check-icon-container:focus:not(:active):not(:hover)
  .check-icon:not(.disabled) {
  @apply ring-offset-2 ring-2 ring-offset-blue;
}

.check-icon-container:active .check-icon:not(.disabled) {
  @apply border-primary;

  &.checked {
    @apply outline-primary-200;
  }
}
</style>
